import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import * as _ from 'lodash';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import withStyles from '@material-ui/styles/withStyles';
import InputBase from '@material-ui/core/InputBase';
import Dialog from '@material-ui/core/Dialog';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import CloseIcon from '@material-ui/icons/Close';
import CalendarEdit from 'assets/svg/calendar_edit.svg';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import DoubleTag from 'assets/svg/double_tag.svg';
import DoubleTagGreen from 'assets/svg/double_tag_green.svg';
import moment from 'moment';
import Button from 'UI/button';
import Footer from 'UI/footer';
import { getIndiaDate, isEqual, shouldShowDiffToggle } from 'utils/common';
import Switch from 'UI/switch';
import {
  ITINERARY_ACTIONS_TYPES,
  ITINERARY_READ_MODES,
  PROMO_CASH_LIMIT,
  TIMEOUT,
} from 'utils/consts';
import PricingDiff from 'components/itineraryMaker/pricingDiff';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import axios from 'axios';
import { baseURL } from 'utils/apiEndpoints';

class Pricing extends Component {
  constructor(props) {
    super(props);
    const { itineraryParts, itineraryActionType, originalPricing } = props;
    this.state = {
      fetchingConversion: true,
      showDiff: false,
      tokenAmount: 0,
      installments: [],
      usablePromoBalance: 0,
      showOfferDialog: false,
      offer: {
        totalSellPrice: 0,
        offerAmount: undefined,
        expiryDate: moment().add(7, 'days').toISOString(),
        offerName: '',
        customOfferName: '',
        finalSellPrice: 0,
      },
    };
    this.flights = [];
    this.services = [];
    this.flightsCostPrice = 0;
    this.flightsSellingPrice = 0;
    this.servicesCostPrice = 0;
    this.servicesSellingPrice = 0;
    for (let i = 0; i < itineraryParts.length; i++) {
      if (itineraryParts[i].type === 'FLIGHT') {
        this.flights.push(itineraryParts[i]);
        this.flightsCostPrice += Number(itineraryParts[i].costPrice);
        this.flightsSellingPrice += Number(itineraryParts[i].sellPrice);
      }
      if (itineraryParts[i].type === 'SERVICE') {
        this.services.push(itineraryParts[i]);
        this.servicesCostPrice += Number(itineraryParts[i].costPrice);
        this.servicesSellingPrice += Number(itineraryParts[i].sellPrice);
      }
    }
    this.flightsCostPrice /= 100;
    this.flightsSellingPrice /= 100;
    this.servicesCostPrice /= 100;
    this.servicesSellingPrice /= 100;
    this.showDiffToggle = shouldShowDiffToggle(itineraryActionType, originalPricing);
    this.debouncedUpdateInstallments = _.debounce((pricingClone, tokenChangeAllowed) => this.updateInstallments(pricingClone, tokenChangeAllowed), 200);
  }

  componentDidMount = () => {
    const {
      suppliers, getConversion, conversion,
      itineraryActionType, installments,
      pricing, onUpdate, tokenPaymentDate,
    } = this.props;
    if (!ITINERARY_READ_MODES[itineraryActionType]) {
      this.setSupplierCost();
    } else {
      const conversionsNotPresent = [];
      for (let i = 0; i < suppliers.length; i++) {
        const supplier = suppliers[i];
        if (!supplier.conversionRate || !conversion[supplier.currency._id]) {
          conversionsNotPresent.push(supplier.currency._id);
        }
      }
      if (conversionsNotPresent.length !== 0) {
        getConversion(conversionsNotPresent.map((c) => ({ fromCurrency: c })));
      }
    }
    const newState = {
      installments,
      tokenAmount: installments?.[0]?.amount || 0,
    };
    if (!_.isNil(pricing.offer?.offerAmount)) {
      newState.offer = pricing.offer;
    }
    this.setState(newState);
    const newPricing = _.cloneDeep(pricing);
    if (_.isNil(newPricing.finalSellPrice)) {
      newPricing.finalSellPrice = newPricing.totalSellPrice - (newPricing.offer?.offerAmount || 0);
    }
    const isOfferExpired = moment().isAfter(newPricing.offer?.expiryDate);
    const isOfferUsed = !_.isNil(tokenPaymentDate) && moment(tokenPaymentDate).isBefore(newPricing.offer?.expiryDate);
    if (_.isNil(newPricing.offer?.offerAmount)
      || (isOfferExpired && !isOfferUsed)) {
      newPricing.offer = {};
      newPricing.finalSellPrice = newPricing.totalSellPrice;
    }
    onUpdate('pricing', newPricing);
    // onUpdate('installments', installments);
    // onUpdate('tokenAmount', installments?.[0]?.amount);
    this.debouncedUpdateInstallments(null, true);
  };

  componentDidUpdate = (prevProps) => {
    const { conversion } = this.props;
    if (!isEqual(conversion, prevProps.conversion)) {
      this.setSupplierCost();
    }
  };

  getValidatedPrices() {
    const { pricing, tokenPaymentDate } = this.props;
    const { totalSellPrice, offer, totalCostPrice } = pricing;
    const isOfferExpired = moment().isAfter(offer.expiryDate);
    const isOfferUsed = !_.isNil(tokenPaymentDate) && moment(tokenPaymentDate).isBefore(offer.expiryDate);
    let { finalSellPrice } = pricing;
    if (offer?.offerAmount > 0 && isOfferExpired && !isOfferUsed) {
      finalSellPrice = totalSellPrice;
    }
    return {
      totalSellPrice,
      finalSellPrice,
      margin: finalSellPrice - totalCostPrice,
      totalCostPrice,
    };
  }

  setSupplierCost = () => {
    const {
      suppliers, getConversion, conversion,
      pricing, onUpdate,
    } = this.props;
    let totalCost = 0;
    const conversionsNotPresent = [];
    if (_.isEmpty(suppliers)) {
      totalCost = pricing.landPackage?.costPrice || 0;
    } else {
      for (let i = 0; i < suppliers.length; i++) {
        const supplier = suppliers[i];
        if (!supplier.conversionRate || !conversion[supplier.currency._id]) {
          conversionsNotPresent.push(supplier.currency._id);
        }
        totalCost += Number(supplier.costPrice) * (supplier.conversionRate / 100);
      }
    }
    if (conversionsNotPresent.length !== 0) {
      this.setState({ fetchingConversion: true });
      getConversion(conversionsNotPresent.map((c) => ({ fromCurrency: c })));
    } else {
      this.setState({ fetchingConversion: false });
      const modPrice = {
        landPackage: {},
        flights: {},
        services: {},
        ...pricing,
      };
      modPrice.landPackage.costPrice = Math.ceil(totalCost);
      modPrice.flights.costPrice = this.flightsCostPrice;
      modPrice.flights.sellPrice = this.flightsSellingPrice;
      modPrice.services.costPrice = this.servicesCostPrice;
      modPrice.services.sellPrice = this.servicesSellingPrice;
      onUpdate('pricing', modPrice);
    }
  };

  handleNestedChange = async (field, subField, value, minValueSubField) => {
    const {
      pricing,
      onUpdate,
      showSnackbar,
    } = this.props;
    const pricingClone = _.cloneDeep(pricing);
    pricingClone[field] = pricingClone[field] || {};
    const finalValue = _.isEmpty(minValueSubField) ? value : Math.max(Number(pricingClone[field][minValueSubField]), Number(value));
    pricingClone[field][subField] = Math.ceil(Math.abs(finalValue));
    pricingClone.totalCostPrice = _.sum([pricingClone.landPackage.costPrice, pricingClone.flights.costPrice, pricingClone.services.costPrice]);
    pricingClone.totalSellPrice = _.sum([pricingClone.landPackage.sellPrice, pricingClone.flights.sellPrice, pricingClone.services.sellPrice]);
    pricingClone.finalSellPrice = pricingClone.totalSellPrice - (pricingClone.offer?.offerAmount || 0);
    if (pricingClone.finalSellPrice < pricingClone.totalCostPrice) {
      if (pricingClone.offer?.offerAmount > 0) {
        if (pricingClone.totalSellPrice < pricingClone.totalCostPrice) {
          showSnackbar('SP cannot be less than CP', 'error');
        } else {
          showSnackbar('Offer price cannot be less than CP', 'error');
        }
      } else {
        showSnackbar('SP cannot be less than CP', 'error');
      }
    }

    onUpdate('pricing', pricingClone);

    if (subField === 'sellPrice') {
      await this.setState({ tokenAmount: 0 });
      this.debouncedUpdateInstallments(pricingClone, true);
    }
  };

  handleB2bPartnerOrderAmountChange = (event) => {
    const { onUpdate } = this.props;
    onUpdate('b2bPartnerOrderAmount', event.target.value);
  }

  handleChange = (field, value) => {
    const { pricing, onUpdate } = this.props;
    const modPrice = { ...pricing };
    modPrice[field] = value;
    onUpdate('pricing', modPrice);
  };

  focusHandler = (e) => {
    e.target.select();
  };

  toggleDiff = () => {
    this.setState((prevState) => ({ showDiff: !prevState.showDiff }));
  };

  renderRow = (title, field, cp = 0, sp = 0) => {
    const { classes, itineraryActionType, showSnackbar } = this.props;
    const margin = _.round(Number(sp) - Number(cp));
    const marginClass = margin >= 0 ? 'profit' : 'loss';
    return (
      <div className={classes.row}>
        <Typography className={classes.title}>{title}</Typography>
        <InputBase
          placeholder="Cost price"
          className={clsx(classes.inputContainer, cp > 0 ? null : classes.loss)}
          classes={{
            input: classes.input,
          }}
          readOnly={ITINERARY_READ_MODES[itineraryActionType] || (itineraryActionType !== ITINERARY_ACTIONS_TYPES.EDIT)}
          onClick={() => {
            if (ITINERARY_READ_MODES[itineraryActionType] || (itineraryActionType !== ITINERARY_ACTIONS_TYPES.EDIT)) {
              showSnackbar('CP edit not allowed', 'warning');
            }
          }}
          onFocus={this.focusHandler}
          startAdornment={<InputAdornment position="start">₹</InputAdornment>}
          type="number"
          value={cp}
          onChange={(e) => this.handleNestedChange(field, 'costPrice', e.target.value)}
        />
        <InputBase
          placeholder="&#8377; Selling price"
          className={clsx(classes.inputContainer, sp > 0 ? null : classes.loss)}
          classes={{
            input: classes.input,
          }}
          readOnly={ITINERARY_READ_MODES[itineraryActionType]}
          onClick={() => {
            if (ITINERARY_READ_MODES[itineraryActionType]) {
              showSnackbar('SP edit not allowed in this mode', 'warning');
            }
          }}
          onFocus={this.focusHandler}
          startAdornment={<InputAdornment position="start">₹</InputAdornment>}
          type="number"
          value={sp}
          onChange={(e) => this.handleNestedChange(field, 'sellPrice', e.target.value)}
        />
        <InputBase
          placeholder="Margin"
          className={clsx(classes.inputContainer, classes.noBorder, classes[marginClass])}
          value={`₹${margin.toLocaleString()}`}
          classes={{
            input: classes.input,
          }}
          onClick={() => {
            showSnackbar('Edit SP to update margin', 'warning');
          }}
          readOnly
        />
      </div>
    );
  };

  createOffer = async () => {
    const { showSnackbar, onUpdate, pricing } = this.props;
    const { offer } = this.state;

    // Validation
    if (!offer.offerName.trim()) {
      showSnackbar('Please enter an offer name', 'error');
      return;
    }

    if (_.isNil(offer.offerAmount) || (offer.offerAmount < 0)) {
      showSnackbar('Please enter a valid offer amount', 'error');
      return;
    }

    if (!offer.expiryDate) {
      showSnackbar('Please select an expiry date', 'error');
      return;
    }

    const pricingClone = _.cloneDeep(pricing);
    pricingClone.offer = offer;
    pricingClone.finalSellPrice = offer.finalSellPrice;
    await onUpdate('pricing', pricingClone);
    await this.updateInstallments(pricingClone, true);
    showSnackbar(`Offer Price ${offer.offerAmount > 0 ? 'updated' : 'removed'} successfully!`, offer.offerAmount > 0 ? 'success' : 'warning');
    this.toggleOfferDialog();
  };

  handleOfferChange = (field, value) => {
    this.setState((prevState) => {
      const newOffer = { ...prevState.offer, [field]: value };

      // Auto-calculate offer price when offer amount changes
      if (field === 'offerAmount') {
        newOffer.offerAmount = Number(value);
        const { pricing, showSnackbar } = this.props;
        if (value > (pricing.totalSellPrice - pricing.totalCostPrice)) {
          showSnackbar('Offer amount cannot be greater than the total margin', 'error');
          return { offer: prevState.offer };
        }
        newOffer.finalSellPrice = Math.max(0, newOffer.totalSellPrice - Number(value));
      }

      if (field === 'customOfferName') {
        newOffer.customOfferName = value.substring(0, 16).toUpperCase();
      }

      if (field === 'expiryDate') {
        newOffer.expiryDate = `${moment(value).format('YYYY-MM-DD')}T23:59:59.999+0530`;
      }

      return { offer: newOffer };
    });
  };

  toggleOfferDialog = () => {
    const { pricing } = this.props;
    const { totalSellPrice, finalSellPrice } = pricing;
    this.setState((prevState) => ({
      showOfferDialog: !prevState.showOfferDialog,
      offer: prevState.showOfferDialog ? prevState.offer : {
        ...prevState.offer,
        totalSellPrice,
        finalSellPrice,
      },
    }));
  };

  updateInstallments(pricingClone, tokenChangeAllowed) {
    const {
      headers,
      itineraryParts,
      pricing,
      onUpdate,
      showSnackbar,
      request,
      itineraryId,
    } = this.props;
    const { tokenAmount } = this.state;
    const url = `${baseURL}itinerary/installments`;
    const multiplyBy100 = (obj) => {
      for (const key in obj) {
        if (typeof obj[key] === 'number') {
          // eslint-disable-next-line no-param-reassign
          obj[key] = _.round(obj[key] * 100);
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
          multiplyBy100(obj[key]);
        }
      }
      return obj;
    };
    const pricingToSend = multiplyBy100(_.cloneDeep(pricingClone || pricing));
    axios({
      method: 'post',
      url,
      data: {
        itinerary: {
          _id: itineraryId,
          request: request?._id,
          pricing: pricingToSend,
        },
        earliestTravelDate: _.min(itineraryParts.map((ip) => ip.startTimeStamp)),
        tokenAmount,
      },
      headers,
      timeout: TIMEOUT,
    })
      .then((resp) => {
        let newTokenAmount = tokenAmount;
        const newState = {
          installments: resp.data.installments,
          originalInstallments: resp.data.originalInstallments,
          usablePromoBalance: resp.data.usablePromoBalance,
          checkingTokenAmount: false,
          commissionPercent: resp.data.commissionPercent,
        };
        if (tokenChangeAllowed) {
          newTokenAmount = Math.min(pricingToSend.finalSellPrice, Math.max(resp.data.installments[0].amount, tokenAmount));
          newState.tokenAmount = newTokenAmount;
          onUpdate('tokenAmount', newTokenAmount);
        }
        this.setState(newState);
        onUpdate('installments', resp.data.installments);
        if (newTokenAmount < resp.data.originalInstallments[0].amount) {
          showSnackbar(`Token amount should not be less than ₹${_.round(resp.data.originalInstallments[0].amount/100)}`, 'error', [], 2000);
        }
      })
      .catch(() => {
      });
  }

  async updateTokenAmount(tokenAmount) {
    const { onUpdate, pricing, showSnackbar } = this.props;
    if (tokenAmount > pricing.finalSellPrice * 100) {
      showSnackbar('Token amount cannot be greater than final price', 'error');
      return;
    }
    await this.setState({
      tokenAmount,
      checkingTokenAmount: true,
    });
    onUpdate('tokenAmount', tokenAmount);
    this.debouncedUpdateInstallments();
  }

  render() {
    const {
      classes, pricing, itineraryActionType, version,
      errorMsg, nextHandler, originalPricing,
      tokenPaymentDate,
    } = this.props;
    const {
      fetchingConversion,
      showDiff,
      tokenAmount,
      checkingTokenAmount,
      installments,
      originalInstallments,
      usablePromoBalance,
      showOfferDialog,
      offer,
      commissionPercent,
    } = this.state;
    const {
      landPackage,
      flights,
      services,
    } = pricing;
    const { totalSellPrice, finalSellPrice, margin } = this.getValidatedPrices();
    const isOfferExpired = moment().isAfter(offer.expiryDate);
    const isOfferUsed = !_.isNil(tokenPaymentDate) && moment(tokenPaymentDate).isBefore(offer.expiryDate);
    return (
      <div className={classes.container}>
        <div className={classes.body}>
          {this.showDiffToggle ? (
            <div className={classes.changeHeader}>
              <Switch
                checked={showDiff}
                onToggle={this.toggleDiff}
                label="VIEW CHANGES"
              />
            </div>
          ) : null}
          {version === 2 ? (
            <>
              {/*
              <Typography className={classes.note}>
                NOTES:
              </Typography>
              <Typography className={classes.notes}>
                - By clicking on request booking button communication will be send to customer,
                to pay the booking amount.
              </Typography>
              <Typography className={classes.notes}>
                - Only after receiving booking amount from customer, only then
                communication will be sent to operation team to process the booking.
              </Typography>
              <Typography className={classes.notes}>
                - Booking status will be updated on CRM by Operation team and same will be
                reflected on customers booking page.
              </Typography>
              */}
              {itineraryActionType === ITINERARY_ACTIONS_TYPES.MODIFY_ITINERARY ? (
                <>
                  <Typography className={classes.notes}>
                    - After modifying, itinerary will be send to Team lead for approval, only after
                    approval changes will be visible to customer.
                  </Typography>
                  <Typography className={classes.notes}>
                    - In caase of rejection, please contact your Team Lead for
                    further clarification.
                  </Typography>
                </>
              ) : null}
            </>
          ) : null}
          <div className={classes.header}>
            <div className={classes.headSpacing} />
            <Typography className={classes.headTitle}>Cost Price</Typography>
            <Typography className={classes.headTitle}>Selling Price</Typography>
            <Typography className={classes.headTitle}>Margin</Typography>
          </div>
          {showDiff
            ? (
              <PricingDiff
                oldData={originalPricing}
                data={pricing}
              />
            )
            : (
              <>
                {this.renderRow('Land Package', 'landPackage', landPackage?.costPrice, landPackage?.sellPrice)}
                {this.flights.length
                  ? this.renderRow('Flights', 'flights', flights?.costPrice, flights.sellPrice) : null}
                {this.services.length
                  ? this.renderRow('Services', 'services', services.costPrice, services.sellPrice) : null}
                <div className={clsx(classes.row, classes.tipsList)}>
                  <div style={{ maxWidth: 300, marginBottom: 10 }}>
                    <InfoOutlinedIcon style={{ fontSize: 16, paddingTop: 5 }} /> Aim <b>for at least 10%</b> margins. Keep <b>~₹{PROMO_CASH_LIMIT.toLocaleString()}</b> extra margin to offer as <b>discounts to serious clients</b>
                  </div>
                </div>
                <div className={classes.totalRow}>
                  <div className={classes.totalRowLeft}>
                    <div className={clsx(classes.font16, classes.bold, classes.textLight)}>Final Price</div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                      <div className={clsx(classes.font24, classes.bold, classes.textDark)}>₹{finalSellPrice.toLocaleString()}</div>
                      {
                        (totalSellPrice > finalSellPrice) ? <div style={{ textDecoration: 'line-through', marginLeft: 10 }} className={clsx(classes.font24, classes.textDark)}>₹{totalSellPrice.toLocaleString()}</div> : null
                      }
                    </div>
                    <div className={classes.offerButtonContainer}>
                      <Button
                        variant="outlined"
                        onClick={this.toggleOfferDialog}
                        className={classes.offerButton}
                      >
                        <img src={DoubleTagGreen} alt="Offer Tip" height={16} width={16} style={{ marginRight: 5 }} />
                        {pricing.offer?.offerAmount > 0 ? 'Edit' : 'Create'} Offer
                      </Button>
                      <div style={{ fontSize: 12, marginTop: 10 }}>
                        {pricing.offer?.offerAmount > 0
                          ? (
                            <span style={{ color: isOfferExpired ? (isOfferUsed ? 'green' : 'red') : null }}><span role="img" aria-label="warning">🚨 </span>
                              Offer {isOfferExpired ? (isOfferUsed ? 'consumed before' : 'expired on') : 'valid till'} <b>{moment(pricing.offer?.expiryDate).format('Do MMM YYYY')}</b>
                            </span>
                          )
                          : '💡 Give limited time offers to push clients to book soon'}
                      </div>
                    </div>
                    <div>
                      <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                      }}
                      >
                        <div style={{ marginRight: 100, width: 100 }} className={clsx(classes.font14, classes.bold, classes.textLight)}><b>Your Earnings</b></div>
                        <div className={clsx(classes.font14, classes.bold, classes.textLight)}><b>Final Markup</b></div>
                      </div>
                      <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                      }}
                      >
                        <div style={{ marginRight: 100, width: 100 }} className={clsx(classes.font24, classes.bold, classes.profit)}>{((margin > 0) && commissionPercent)? `₹${_.round((margin * commissionPercent)/100).toLocaleString()}` : '--'}</div>
                        <div className={clsx(classes.font16, classes.bold, classes.textDark)}>{margin > 0 ? `₹${margin.toLocaleString()}` : '--'}</div>
                      </div>
                    </div>
                  </div>
                  <div className={classes.totalRowRight}>
                    <div>
                      <Typography className={clsx(classes.title, classes.tokenText)}>Token Amount {checkingTokenAmount ? '...' : ''}</Typography>
                      <InputBase
                        className={
                          clsx(classes.inputContainer,
                            classes[((tokenAmount === 0) || (tokenAmount >= originalInstallments?.[0]?.amount))
                              ? 'profit'
                              : 'loss'])
                        }
                        startAdornment={<InputAdornment position="start">₹</InputAdornment>}
                        type="number"
                        onChange={(e) => this.updateTokenAmount(e.target.value * 100)}
                        value={(_.isNil(tokenAmount) ? installments?.[0]?.amount : tokenAmount)/100}
                      />
                      {
                        ((tokenAmount/100 < pricing.finalSellPrice) && (tokenAmount >= installments?.[0]?.amount)) ? (
                          <div style={{ fontSize: 12, marginTop: 10, marginLeft: 16 }}>
                            Remaining amount of ₹{_.round((_.sumBy(installments, 'amount') - tokenAmount)/100).toLocaleString()} to be paid by {getIndiaDate(_.last(installments)?.dueDate)}
                          </div>
                        ) : null
                      }
                      {
                        usablePromoBalance > 0
                          ? (
                            <Typography className={classes.promoCashNote} style={{ marginLeft: 16 }}>
                              * Client can use ₹{PROMO_CASH_LIMIT.toLocaleString()} promo cash to get further discounts, this will be deducted from total margins
                            </Typography>
                          )
                          : null
                      }
                    </div>
                  </div>
                </div>
              </>
            )}
        </div>
        {nextHandler ? (
          <Footer
            errorMsg={errorMsg}
          >
            <Button
              onClick={nextHandler}
              disabled={fetchingConversion}
              className={clsx(classes.createButton, fetchingConversion && classes.disabled)}
            >
              Save & Continue
            </Button>
          </Footer>
        ) : null}
        <Dialog
          open={showOfferDialog}
          onClose={this.toggleOfferDialog}
          maxWidth="sm"
          fullWidth
          classes={{
            paper: classes.offerDialog,
          }}
        >
          <div className={classes.offerDialogHeader}>
            <div className={classes.offerDialogTitleContainer}>
              <div className={classes.offerDialogIcon}>
                <img src={DoubleTag} alt="Offer Pricing" />
              </div>
              <Typography className={classes.offerDialogTitle}>Offer Pricing</Typography>
            </div>
            <CloseIcon className={classes.closeIcon} onClick={this.toggleOfferDialog} />
          </div>

          <div className={classes.offerDialogBody}>
            <div className={classes.offerRow}>
              <div>
                <Typography className={classes.offerLabel}>Total Selling Price</Typography>
                <Typography className={classes.offerValue}>₹{offer.totalSellPrice.toLocaleString()}</Typography>
              </div>
            </div>

            <div className={classes.offerRow}>
              <div style={{ marginRight: 20 }}>
                <Typography className={classes.offerLabel}>Discount</Typography>
                <InputBase
                  className={classes.offerInput}
                  startAdornment={<InputAdornment position="start">₹</InputAdornment>}
                  type="number"
                  value={offer.offerAmount}
                  onChange={(e) => this.handleOfferChange('offerAmount', e.target.value)}
                  classes={{
                    input: classes.offerInputText,
                  }}
                />
              </div>

              <div>
                <Typography className={classes.offerLabel}>Expiry Date</Typography>
                <div className={classes.datePickerContainer}>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <img src={CalendarEdit} alt="Calendar" height={20} width={20} />
                    <DatePicker
                      style={{ width: 100, textAlign: 'center' }}
                      disablePast
                      format="D MMM YYYY"
                      value={moment().isAfter(offer.expiryDate, 'days') ? null : moment(offer.expiryDate).format('YYYY-MM-DD')}
                      onChange={(date) => this.handleOfferChange('expiryDate', date)}
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </div>
            </div>

            <div className={classes.offerRow}>
              <div>
                <Typography className={classes.offerLabel}>Offer Name</Typography>
                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
                >
                  <div className={classes.offerNameContainer}>
                    <Select
                      value={offer.offerName}
                      onChange={(e) => {
                        this.handleOfferChange('offerName', e.target.value);
                        if (e.target.value === 'custom') {
                          setTimeout(() => {
                            document.querySelector('.offerNameInput')?.focus();
                          }, 100);
                        }
                      }}
                      className={classes.offerSelect}
                      displayEmpty
                      renderValue={(value) => value?.split('-').map((word) => _.upperCase(word)).join(' ') || 'Select a offer name'}
                    >
                      <MenuItem value="early-bird-offer">EARLY BIRD OFFER</MenuItem>
                      <MenuItem value="last-minute-saver">LAST MINUTE SAVER</MenuItem>
                      <MenuItem value="flash-sale">FLASH SALE</MenuItem>
                      <MenuItem value="referral-offer">REFERRAL OFFER</MenuItem>
                      <MenuItem value="anniversary-offer">ANNIVERSARY OFFER</MenuItem>
                      <MenuItem value="honeymoon-offer">HONEYMOON OFFER</MenuItem>
                      <MenuItem value="birthday-offer">BIRTHDAY OFFER</MenuItem>
                      <MenuItem value="diwali-deal">DIWALI DEAL</MenuItem>
                      <MenuItem value="christmas-offer">CHRISTMAS OFFER</MenuItem>
                      <MenuItem value="new-year-bonanza">NEW YEAR BONANZA</MenuItem>
                      <MenuItem value="summer-specials">SUMMER SPECIALS</MenuItem>
                      <MenuItem value="loyalty-offer">LOYALTY OFFER</MenuItem>
                      <MenuItem value="monsoon-magic-offer">MONSOON MAGIC OFFER</MenuItem>
                      <MenuItem value="weekend-deal">WEEKEND DEAL</MenuItem>
                      <MenuItem value="group-deal">GROUP DEAL</MenuItem>
                      <MenuItem value="custom">CUSTOM</MenuItem>
                    </Select>
                  </div>
                  {
                    offer.offerName === 'custom' ? (
                      <InputBase
                        className={classes.offerNameInput}
                        value={offer.customOfferName}
                        placeholder="Enter an offer name"
                        onChange={(e) => this.handleOfferChange('customOfferName', e.target.value)}
                      />
                    ) : null
                  }
                </div>
              </div>
            </div>

            <div className={classes.offerPriceSection}>
              <Typography className={classes.offerLabel}>Offer Price</Typography>
              <Typography className={classes.offerValue}>₹{offer.finalSellPrice.toLocaleString()}</Typography>
              {
                usablePromoBalance > 0
                  ? (
                    <Typography className={classes.promoCashNote}>
                      * Client can use ₹{PROMO_CASH_LIMIT.toLocaleString()} promo cash to get further discounts, this will be deducted from total margins
                    </Typography>
                  )
                  : null
              }
            </div>
            <Button
              onClick={this.createOffer}
              className={classes.createOfferButton}
              disabled={!offer.offerName || _.isNil(offer.offerAmount) || !offer.expiryDate || (offer.offerName === 'custom' && !offer.customOfferName)}
            >
              {pricing.offer?.offerAmount > 0 ? 'Update' : 'Create'} Offer
            </Button>
          </div>
        </Dialog>
      </div>
    );
  }
}

const styles = (theme) => ({
  font14: {
    fontSize: 14,
  },
  font16: {
    fontSize: 16,
  },
  font24: {
    fontSize: 24,
  },
  bold: {
    fontWeight: 'bold',
  },
  textLight: {
    color: theme.colors.textLight,
  },
  textDark: {
    color: theme.colors.textDark,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    backgroundColor: theme.colors.white,
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: '20px 40px',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  changeHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: 10,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headSpacing: {
    width: 140,
    backgroundColor: 'transparent',
  },
  tokenText: {
    flex: 1,
    marginLeft: 16,
  },
  headTitle: {
    flex: 1,
    marginLeft: 16,
    padding: '10px 15px',
    height: 40,
    color: theme.colors.textDark,
    textAlign: 'right',
  },
  title: {
    fontSize: 16,
    color: theme.colors.black,
    width: 140,
    height: 40,
    display: 'flex',
    alignItems: 'center',
  },
  inputContainer: {
    color: theme.colors.black,
    flex: 1,
    marginTop: 10,
    marginLeft: 16,
    width: 140,
    padding: '10px 15px',
    height: 40,
    boxSizing: 'border-box',
    borderRadius: 4,
    border: `1px solid ${theme.colors.border}`,
  },
  input: {
    textAlign: 'right',
  },
  focusedInput: {
    border: `1px solid ${theme.colors.primary}`,
  },
  profit: {
    color: theme.colors.green,
  },
  loss: {
    color: theme.colors.red,
  },
  totalRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 10,
    '& .smallLabel': {
      color: theme.colors.textLight,
    },
    '& .label': {
      color: theme.colors.textLight,
    },
    '& .smallValue': {
      color: theme.colors.textDark,
    },
    '& .value': {
      color: theme.colors.textDark,
    },
  },
  totalRowLeft: {
    flex: 2,
    borderRight: `1px solid ${theme.colors.border}`,
  },
  totalRowRight: {
    flex: 3,
    marginLeft: 25,
    alignSelf: 'start',
  },
  totalText: {
    color: theme.colors.textDark,
  },
  alignRight: {
    justifyContent: 'end',
  },
  totalInput: {
    color: theme.colors.textDark,
    border: 'none',
  },
  redColor: {
    color: theme.colors.red,
  },
  primaryColor: {
    color: theme.colors.primary,
  },
  summaryRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    marginLeft: 'auto',
  },
  summaryLabel: {
    fontSize: 16,
    color: theme.colors.textDark,
    letterSpacing: 0.5,
  },
  createButton: {
    width: 180,
    fontSize: 14,
    borderRadius: 25,
    fontWeight: 'bold',
    color: theme.colors.white,
    backgroundColor: theme.colors.primaryBackground,
    '&:hover': {
      backgroundColor: theme.colors.primary,
    },
  },
  disabled: {
    backgroundColor: theme.colors.grey,
    color: theme.colors.white,
    cursor: 'not-allowed',
  },
  note: {
    margin: '0 0 8px',
    fontWeight: 'bold',
    fontSize: 14,
    color: theme.colors.textDark,
  },
  notes: {
    margin: '6px 0',
    fontWeight: 'bold',
    fontSize: 14,
    color: theme.colors.textLight,
  },
  tipsList: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: 12,
    borderBottom: `1px solid ${theme.colors.border}`,
  },
  noBorder: {
    border: 'none',
  },
  offerButtonContainer: {
    marginTop: 30,
    marginBottom: 30,
  },
  offerButton: {
  },
  offerDialog: {
    borderRadius: 12,
    minHeight: 500,
    color: theme.colors.black,
  },
  offerDialogHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
    padding: '40px 40px 20px 40px',
    borderBottom: `1px solid ${theme.colors.border}`,
  },
  offerDialogTitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  offerDialogIcon: {
    fontSize: 24,
    marginRight: 12,
  },
  offerDialogTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: theme.colors.black,
  },
  closeIcon: {
    cursor: 'pointer',
    color: theme.colors.textDark,
    fontSize: 24,
    '&:hover': {
      color: theme.colors.black,
    },
  },
  offerDialogBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 40px 40px 40px',
    gap: 20,
  },
  offerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginTop: 20,
  },
  offerLabel: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.colors.black,
    marginBottom: 10,
  },
  offerValue: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  offerInput: {
    border: `1px solid ${theme.colors.border}`,
    borderRadius: 8,
    padding: '12px 16px',
    height: 40,
    width: 160,
    fontSize: 16,
    color: theme.colors.black,
    backgroundColor: theme.colors.white,
    '&:focus-within': {
      borderColor: theme.colors.primary,
    },
  },
  offerInputText: {
    fontSize: 16,
    color: theme.colors.black,
    textAlign: 'end',
    '&::placeholder': {
      color: theme.colors.textLight,
    },
  },
  datePickerContainer: {
    position: 'relative',
    border: `1px solid ${theme.colors.border}`,
    borderRadius: 8,
    padding: '5px 10px',
    height: 40,
    width: 160,
    fontSize: 16,
    color: theme.colors.black,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& input': {
      textAlign: 'center',
    },
    '& :before': {
      borderBottom: 'none !important',
    },
  },
  hiddenDatePicker: {
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    cursor: 'pointer',
  },
  calendarIcon: {
    color: theme.colors.textDark,
    fontSize: 20,
    cursor: 'pointer',
  },
  offerNameContainer: {
    display: 'flex',
    height: 40,
    flexDirection: 'row',
    alignItems: 'center',
    border: `1px solid ${theme.colors.border}`,
    borderRadius: 8,
    padding: '8px 12px',
    backgroundColor: theme.colors.white,
    position: 'relative',
    width: 200,
    '& :before': {
      borderBottom: 'none !important',
    },
    '& :after': {
      borderBottom: 'none !important',
    },
    '& :focus': {
      backgroundColor: 'transparent',
    },
  },
  offerNameAvatar: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    backgroundColor: '#E91E63',
    color: theme.colors.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    fontWeight: 'bold',
    marginRight: 12,
  },
  offerSelect: {
    flex: 1,
    border: 'none',
    outline: 'none',
    fontSize: 16,
    '& .MuiSelect-select': {
      border: 'none',
      outline: 'none',
      padding: 0,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
  dropdownIcon: {
    marginLeft: 8,
    color: theme.colors.textDark,
    fontSize: 12,
  },
  offerPriceSection: {
    marginTop: 20,
  },
  offerPriceLabel: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.colors.black,
    marginBottom: 8,
  },
  offerPriceValue: {
    fontSize: 24,
    fontWeight: 'bold',
    color: theme.colors.black,
    marginBottom: 8,
  },
  promoCashNote: {
    marginTop: 10,
    fontSize: 12,
    color: '#CC3254',
  },
  createOfferButton: {
    width: '150px',
    marginTop: 20,
  },
  offerNameInput: {
    border: `1px solid ${theme.colors.border}`,
    borderRadius: 8,
    padding: '12px 16px',
    height: 40,
    width: 250,
    marginLeft: 10,
  },
});

Pricing.propTypes = {
  classes: PropTypes.object,
  pricing: PropTypes.object.isRequired,
  isB2bBooking: PropTypes.bool,
  b2bPartnerOrderAmount: PropTypes.number,
  itineraryParts: PropTypes.array.isRequired,
  onUpdate: PropTypes.func.isRequired,
  nextHandler: PropTypes.func,
  errorMsg: PropTypes.string,
  suppliers: PropTypes.array.isRequired,
  getConversion: PropTypes.func.isRequired,
  conversion: PropTypes.object.isRequired,
  itineraryActionType: PropTypes.string.isRequired,
  originalPricing: PropTypes.object,
  routes: PropTypes.object,
  headers: PropTypes.object,
  expert: PropTypes.object.isRequired,
  version: PropTypes.number,
  installments: PropTypes.array,
  showSnackbar: PropTypes.func,
  request: PropTypes.object.isRequired,
  itineraryId: PropTypes.string.isRequired,
  tokenPaymentDate: PropTypes.string,
};

export default withStyles(styles)(Pricing);
